var __values = this && this.__values || function (o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
};

import StitchError from "../../StitchError";
import StitchRequestError from "../../StitchRequestError";
import Event from "./Event";
import StitchEvent from "./StitchEvent";

var BaseEventStream = function () {
  function BaseEventStream(reconnecter) {
    this.reconnecter = reconnecter;
    this.closed = false;
    this.events = [];
    this.listeners = [];
    this.lastErr = undefined;
  }

  BaseEventStream.prototype.isOpen = function () {
    return !this.closed;
  };

  BaseEventStream.prototype.addListener = function (listener) {
    var _this = this;

    if (this.closed) {
      setTimeout(function () {
        return listener.onEvent(new Event(StitchEvent.ERROR_EVENT_NAME, "stream closed"));
      }, 0);
      return;
    }

    if (this.lastErr !== undefined) {
      setTimeout(function () {
        return listener.onEvent(new Event(StitchEvent.ERROR_EVENT_NAME, _this.lastErr));
      }, 0);
      return;
    }

    this.listeners.push(listener);
    this.poll();
  };

  BaseEventStream.prototype.removeListener = function (listener) {
    var index = this.listeners.indexOf(listener);

    if (index === -1) {
      return;
    }

    this.listeners.splice(index, 1);
  };

  BaseEventStream.prototype.nextEvent = function () {
    var _this = this;

    if (this.closed) {
      return Promise.reject(new Event(StitchEvent.ERROR_EVENT_NAME, "stream closed"));
    }

    if (this.lastErr !== undefined) {
      return Promise.reject(new Event(StitchEvent.ERROR_EVENT_NAME, this.lastErr));
    }

    return new Promise(function (resolve, reject) {
      _this.listenOnce({
        onEvent: function onEvent(e) {
          resolve(e);
        }
      });
    });
  };

  BaseEventStream.prototype.close = function () {
    if (this.closed) {
      return;
    }

    this.closed = true;
    this.afterClose();
  };

  BaseEventStream.prototype.reconnect = function (error) {
    var _this = this;

    if (!this.reconnecter) {
      if (!this.closed) {
        this.closed = true;
        this.events.push(new Event(StitchEvent.ERROR_EVENT_NAME, "stream closed: " + error));
        this.poll();
      }

      return;
    }

    this.reconnecter().then(function (next) {
      _this.onReconnect(next);
    }).catch(function (e) {
      if (!(e instanceof StitchError) || !(e instanceof StitchRequestError)) {
        _this.closed = true;

        _this.events.push(new Event(StitchEvent.ERROR_EVENT_NAME, "stream closed: " + error));

        _this.poll();

        return;
      }

      setTimeout(function () {
        return _this.reconnect(e);
      }, BaseEventStream.RETRY_TIMEOUT_MILLIS);
    });
  };

  BaseEventStream.prototype.poll = function () {
    var e_1, _a;

    while (this.events.length !== 0) {
      var event_1 = this.events.pop();

      try {
        for (var _b = __values(this.listeners), _c = _b.next(); !_c.done; _c = _b.next()) {
          var listener = _c.value;

          if (listener.onEvent) {
            listener.onEvent(event_1);
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }
  };

  BaseEventStream.prototype.listenOnce = function (listener) {
    var _this = this;

    if (this.closed) {
      setTimeout(function () {
        return listener.onEvent(new Event(StitchEvent.ERROR_EVENT_NAME, "stream closed"));
      }, 0);
      return;
    }

    if (this.lastErr !== undefined) {
      setTimeout(function () {
        return listener.onEvent(new Event(StitchEvent.ERROR_EVENT_NAME, _this.lastErr));
      }, 0);
      return;
    }

    var wrapper = {
      onEvent: function onEvent(e) {
        _this.removeListener(wrapper);

        listener.onEvent(e);
      }
    };
    this.addListener(wrapper);
  };

  BaseEventStream.RETRY_TIMEOUT_MILLIS = 5000;
  return BaseEventStream;
}();

export default BaseEventStream;